<script setup lang="ts">
import type { TableColumn } from '@nuxt/ui'
import { computed, h, resolveComponent } from 'vue'

const { broker } = useBroker()

const ULink = resolveComponent('ULink')

// Add id to locations
const locationsWithId = computed(
  () =>
    broker.value?.top_5_locations?.map(location => ({
      ...location,
      id: location.city_slug,
    })) ?? [],
)

const buildLink = (city_slug: string) => {
  const loc = locationsWithId.value.find(l => l.id === city_slug)
  return `/makelaars/${loc?.province_slug}/${loc?.city_slug}`
}

interface LocationData {
  id?: string
  city_slug: string
  province_slug?: string
  name: string
  transactions_count: number
  avg_price: string
}

const columns: TableColumn<LocationData>[] = [
  {
    accessorKey: 'name',
    header: 'Plaats',
    cell: ({ row }) => {
      return h(
        'h4',
        {
          class: 'text-sm font-semibold text-gray-600 text-nowrap normal-nums',
        },
        row.getValue('name'),
      )
    },
  },
  {
    accessorKey: 'transactions_count',
    header: 'Aantal transacties',
    cell: ({ row }) => {
      return h(
        'span',
        {
          class: 'text-sm text-gray-600 text-nowrap normal-nums',
        },
        row.getValue('transactions_count'),
      )
    },
  },
  {
    accessorKey: 'avg_price',
    header: 'Gemiddelde prijs',
    cell: ({ row }) => {
      return h(
        'span',
        {
          class: 'text-sm text-gray-600 text-nowrap normal-nums',
        },
        row.getValue('avg_price'),
      )
    },
  },
  {
    accessorKey: 'city_slug',
    header: 'Bekijk makelaars',
    cell: ({ row }) => {
      const link = buildLink(row.getValue('city_slug'))

      return h(
        ULink,
        {
          class: 'no-underline',
          to: link,
        },
        () => `Makelaars in ${row.getValue('name')}`,
      )
    },
  },
]
</script>

<template>
  <div
    v-if="broker?.top_5_locations"
    class="not-prose"
  >
    <div class="flex-1 divide-y divide-[var(--ui-border)] w-full border border-[var(--ui-border)] rounded-md">
      <UTable
        sticky
        :columns="columns"
        :data="locationsWithId"
      />
    </div>
  </div>
</template>
